// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"CartMiniFooter_footerContainer__GHsBG","button":"CartMiniFooter_button__QlaPb","footerShadow":"CartMiniFooter_footerShadow__gjM2y"};